import React from "react";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import LanguageIcon from "@material-ui/icons/Language";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import { languages } from "../../constants/languages";
import { languageNames } from "../../constants/languages";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";

const styles = theme => ({
  button: {
    [theme.breakpoints.down("sm")]: {
      display: "none"
    }
  },
  iconButton: {
    display: "none",
    [theme.breakpoints.down("sm")]: {
      display: "block"
    }
  }
});

const LanguageMenu = props => (
  <div>
    <Button
      className={props.classes.button}
      aria-owns={props.open ? "menu-appbar" : null}
      aria-haspopup="true"
      onClick={props.handleMenu}
      color="inherit"
      style={{ color: "white" }}
    >
      <LanguageIcon style={{ height: 25, marginRight: 5 }} />
      <span className={props.classes.buttonText}>
        {languageNames[languages.getLanguage()] || ""}
      </span>
    </Button>
    <IconButton
      className={props.classes.iconButton}
      aria-owns={props.open ? "menu-appbar" : null}
      aria-haspopup="true"
      onClick={props.handleMenu}
      color="inherit"
      style={{ color: "white" }}
    >
      <LanguageIcon style={{ height: 25, marginRight: 5 }} />
    </IconButton>
    <Menu
      id="menu-appbar"
      anchorEl={props.anchorEl}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right"
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right"
      }}
      open={props.open}
      onClose={props.handleClose}
      style={{ zIndex: 1302 }}
    >
      {languages.getAvailableLanguages().map(lang => {
        return (
          <MenuItem
            key={lang}
            onClick={() => {
              props.changeLanguage(lang);
            }}
          >
            {languageNames[lang] || ""}
          </MenuItem>
        );
      })}
    </Menu>
  </div>
);

LanguageMenu.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(LanguageMenu);
